var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94917 4.52631V1.05664H13.1574V14.0755H13.902V14.943H1.99999V4.52631H7.94917ZM9.43832 14.0755H11.6682V12.3407H9.43832V14.0755ZM8.69375 10.6058H12.4128V9.73472H8.69375V10.6058ZM8.69375 8.86726H12.4128V7.9998H8.69375V8.86726ZM8.69375 7.13234H12.4128V6.26487H8.69375V7.13234ZM8.69375 5.39759H12.4128V4.52631H8.69375V5.39759ZM8.69375 3.65885H12.4128V2.79157H8.69375V3.65885ZM4.97449 13.2082H6.46365V11.4733H4.97449V13.2082ZM4.97449 10.6058H6.46365V8.86726H4.97449V10.6058ZM4.97449 7.9998H6.46365V6.26487H4.97449V7.9998ZM2.74457 13.2082H4.22991V11.4733H2.74457V13.2082ZM2.74457 10.6058H4.22991V8.86726H2.74457V10.6058ZM2.74457 7.9998H4.22991V6.26487H2.74457V7.9998Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.8bea1956d37ab15847a441103fe1eda2.svg";
export { ForwardRef as ReactComponent };